import { Box, Dialog, IconButton, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import Login from './Login'
import SignUp from './SignUp'
import ForgotPassword from './ForgotPassword'
import AuthAside from './AuthAside'
import { Close } from '@mui/icons-material'

interface AuthDialogProps {
  authStep: string
  open: boolean
  onClose: () => void
}

const AuthDialog = ({ authStep, open, onClose }: AuthDialogProps) => {
  const theme = useTheme()
  const lessThanMedium = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='xl'
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 'var(--ds-radius-lg, 20px)',
          maxWidth: '1080px',
          maxHeight: '90vh',
          backgroundColor: 'var(--ds-canvas)',
          overflow: 'hidden',
          boxShadow: 'var(--ds-shadow-lift, 0 20px 60px rgba(0, 0, 0, 0.3))',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          height: '100%',
          minHeight: '600px',
          position: 'relative',
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: 16,
            zIndex: 10,
            width: 38,
            height: 38,
            color: 'var(--ds-ink)',
            backgroundColor: 'var(--ds-canvas)',
            boxShadow: 'inset 0 0 0 1px var(--ds-border-strong)',
            transition: 'background var(--ds-duration-fast) var(--ds-ease)',
            '&:hover': { backgroundColor: 'var(--ds-hover)' },
          }}
          aria-label='Close'
        >
          <Close fontSize='small' />
        </IconButton>

        {!lessThanMedium && (
          <Box sx={{ flex: 1, display: 'flex' }}>
            <AuthAside />
          </Box>
        )}

        <Box
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'var(--ds-canvas)',
            overflowY: 'auto',
          }}
        >
          {authStep === 'login' ? (
            <Login />
          ) : authStep === 'signup' ? (
            <SignUp />
          ) : (
            authStep === 'forgot-password' && <ForgotPassword />
          )}
        </Box>
      </Box>
    </Dialog>
  )
}

export default AuthDialog
